<template>
  <section id="resume">
    <div class="position">
      <TheAvatar
        :img="require('@/assets/avatar/avatar-profile.svg')"
        max-width="200px"
      />
    </div>

    <div class="cards">
      <Card
        title="Cursos"
        :value="totalCourses"
        :icon="require('@/assets/cards/cursos.svg')"
      />

      <Card
        title="Alunos"
        :value="totalStudents"
        :icon="require('@/assets/cards/alunos.svg')"
      />

      <Card title="Avaliação" :icon="require('@/assets/cards/avaliacao.svg')">
        <div class="rating">
          <!--<span class="value">{{ rating }}</span>
          <img src="@/assets/cards/star.svg" />
          <img src="@/assets/cards/star.svg" />
          <img src="@/assets/cards/star.svg" />
          <img src="@/assets/cards/star.svg" />
          <img src="@/assets/cards/star.svg" />-->
          <el-rate
          v-model="rating"
          disabled
          show-score
          text-color="#ff9900">
        </el-rate>
        </div> 
        
      </Card>
    </div>
  </section>
</template>

<script>
import TheAvatar from '@/views/layout/avatar/';
import Card from '@/components/atomic/organisms/Card.vue';
import axios from 'axios';

export default {
  name: 'UserResume',

  components: {
    TheAvatar,
    Card,
  },

  props: {
    img: {
      type: String,
      required: false,
      default: '@/assets/avatar/avatar-profile.svg',
    },
    totalCourses: { type: Number, required: true },
    totalStudents: { type: Number, required: true },
    rating: { type: Number, required: true },
  },
  computed: {
    userAvatar() {
      return this.img;
    },
  },

  async mounted() {
    await this.getUser();
  },
  methods: {
    async getUser() {
      const id = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      const { data } = await axios.get(`${process.env.VUE_APP_API}/user/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
      });
      let students = 0;
      data.courses.filter(course => {
        if (course.students.length > 0) {
          students += course.students.length;
        }
      });
      let nota = 0;
      let SumGeral = 0;
      data.courses.filter(course => {
        if(course.avaliations.length > 0) {
          course.avaliations.filter(avaliation =>{
            nota+=avaliation.nota;
          })
          SumGeral += nota;
        }
        
      })

      this.totalStudents = students;
      this.totalCourses = data.courses.length; 
      this.rating = ((SumGeral) / this.totalStudents).toFixed(2);
      // this.rating = nota;
      console.log(SumGeral);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-rate{
  display: inline!important;
}
#resume {
  display: flex;
  margin: 18px 0;
  position: relative;
  padding-left: 240px;

  .position {
    position: absolute;
    top: -100px;
    left: 42px;
    width: 170px;
    height: 170px;
    background: #041586;
    border-radius: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .cards {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    gap: 20px;
  }

  .rating {
    display: flex;
    flex-direction: row;
  }
}

@media (max-width: 768px) {
  #resume {
    padding-left: 0;
    margin-left: 0;
    margin-right: 0;

    .position {
      display: none;
    }

    .cards {
      flex-direction: column;
      margin-top: 0;
    }
  }
}
</style>
